export default __webpack_public_path__ + "static/media/persons.52f39fc2.svg";